import React from 'react';
import { Field } from 'redux-form';
import {
  FormStyled,
  Text,
  ButtonGroup,
  LinkWrapper,
  Link,
  Msg
} from '../Form/styled';
import { Button } from '@app/src/components/Button';
import { RenderInputMfa } from '@app/src/views/LoginMfa/RenderInputMfa';
import { required } from '@app/src/utils/validations';

export const Form = ({
  handleSubmit,
  errorMessage,
  isFetching,
  resendOtp,
  urlResendOtp
}) => {

  const handleResendClick = () => {
    resendOtp(urlResendOtp);
  };

  return (
    <FormStyled data-test="loginMfaForm" onSubmit={handleSubmit}>
      <Msg data-test="errorMessage">{errorMessage}</Msg>

      <Field
        name="otp"
        data-test="otpInputKey"
        type="text"
        dataLabel="otpLabelVerificationText"
        dataSpan="otpSpanCodeMessage"
        label="Código de verificación"
        component={RenderInputMfa}
        validate={[required]}
      />

      <Text data-test="otpSpanCodeExpireMessage" style={{ marginTop: '0px', marginBottom: '10px' }}>
        El código vencerá en 2 minutos
      </Text>

      <ButtonGroup>
        <Button
          data-test="btnLogin"
          type="submit"
          primary
          fullWidth
          loading={isFetching}
        >
          Enviar
        </Button>
      </ButtonGroup>
      <LinkWrapper >
        <Link data-test="forgetPassword" onClick={handleResendClick} >Enviar nuevo código de verificación</Link>
      </LinkWrapper>
    </FormStyled>
  );
};
